export default {
  resource:{
    zh: {
      companyNo:"公司",
      companyName:"公司",
      deptNo:"部门",
      deptName:"部门",
      xgroup:"组别",
      duty:"职务",
      job:"岗位",
      jobTitle:"职称",
      basePay:"基本工资",
      jobPay:"岗位工资",
      meritsPay:"绩效奖",
      fullAttdPay:"全勤奖",
      restDays: "工休",
      restType_2:"每周六、日",
      restType_1:"每周日",
      restType0:"无",
      restType1:"1天",
      restType2:"2天",
      restType3:"3天",
      restType4:"4天",
      restType5:"5天",
      restType6:"6天",
      restType7:"7天",
      restType8:"8天",
      foodSubsidy: "伙食补贴",
      empId: "工号",
      empName:"姓名",
      sex:"性别",
      sex1: "男",
      sex2: "女",
      status:"状态",
      status1: "在职",
      status2: "离职",
      salaryType:"薪别",
      salaryMethod: "计薪方法",
      salaryBase:"基本工资",
      salaryPost:"职位薪贴",
      startAge:"入厂年龄",
      workMonth:"工龄(月)",
      bankAccount:"银行账号",
      bankName :"开户银行",
      sname: "计薪方法",
      workMonthPay: "工龄奖(每月)",
      hotPay: "高温补贴(每天)",
      socialSecurity:"申报工资",
      taxChild:"子女教育",
      taxEducation:"继续教育",
      taxLoan:"房贷利息",
      taxRent:"房租",
      taxParent:"赡养父母"
    }

  },
  delConf:["deptName", "job"],
  isShowMore: true,
  params: {
    companyNo: {
      key: "companyNo",
      defaultIdx: 0,
      method: "Equal",
      type: "select",
      options: "company"
    },
    dept: {
      key: "deptNo",
      tkey: "deptNo",
      data: "",
      method: "Equal",
      type: "select",
      options: [{
        value: "",
        text: "All"
      }]
    },
    job:{
      key: "job",
      data: null,
      method: "Equal",
      type: "text"
    },
    empId: {
      key: "empId",
      data: "",
      method: "Equal",
      type: "number"
    },
    empName: {
      key: "empName",
      data: "",
      method: "Contains",
      type: "text"
    },
    status: {
      key: "status",
      data: "1",
      method: "Equal",
      type: "select",
      more: true,
      options: [{
        value: "",
        text: "All"
      }, {
        value: "1",
        text: "在职"
      }, {
        value: "2",
        text: "离职"
      }]
    }
  },
  listDefine: [
    "companyName",
    "empId",
    "empName",
    {key:"sex", formatter:"fsex"},
    "deptName",
    "xgroup",
    "duty",
    "job",
    "jobTitle", "sname", 'basePay', 'jobPay', { key: 'restDays', formatter: "frd" },
    'foodSubsidy', "workMonthPay", "hotPay","socialSecurity"
    , "bankAccount", "bankName", "taxChild","taxEducation","taxLoan","taxRent","taxParent"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"empId",
  defaultSortOrder:"desc",
  sortName: "empId",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "EmpSalary/",
  autoId: "autoid",
  formatter: {
    fsex(t) {
      return 'sex' + t
    },
    fstatus(t) {
      return 'status' + t
    },
    frd(t) {
      if (!t) return "restType0" 
      if(parseInt(t) == -1) {
        return "restType_1"
      } else if(parseInt(t) == -2) {
        return "restType_2"
      }
      return "restType" + t
    }
  }

}
